import loadable from '@loadable/component'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import { Loading } from '@/components/common/loading/Loading'
import { BILL_PAYMENT_ROUTES, ENTRY_ROUTE_QUERY, ROOT } from '@/domains/CommonDomain'
import { PAYMENT_TYPE_CODE } from '@/domains/version/V2/BillPaymentDomain'
import { useBackButton } from '@/hooks/useBackButton'
import { useTrans } from '@/hooks/useTrans'
import { errorSelector } from '@/modules/common/error'
import { historyActions } from '@/modules/common/history'
import { versionActions } from '@/modules/common/version'
import { billMainActions } from '@/modules/version/V2/bill-payment/BillPaymentMainModule'
import { browserHistory, goBack, HISTORY_ACTION_TYPE } from '@/utils/historyUtils'
import {
  getBillPaymentComponentByVersion,
  getSchedulePaymentComponentByVersion,
} from '@/utils/versionUtils'

import { cmodeValue, deeplink_name,getParam, version_name } from '..'
import { EnforcedMessagePageError } from './common/error/EnforcedMessagePageError'
import { ErrorSection } from './common/error/ErrorSection'
import { FullPageError } from './common/error/FullPageError'

export let goPaymentMainUrl: string = ''
export let ApiUrlErrorMsg: string = ''

// billpayment deeplink 용 function
export const deeplinkFn = (() => {
  // let deeplinkVal: any = '03' // 초기값(개발자 테스트용)
  let deeplinkVal: any = null // 초기값

  return {
    get: () => {
      return deeplinkVal
    },
    set: (val: any) => {
      deeplinkVal = val
    },
  }
})()

// billpayment deeplink 변환코드 array
const deeplinkArrData = [
  { value: 'EWALLET', code: PAYMENT_TYPE_CODE.TOPUP }, // e-wallat topup
  { value: 'BILLS', code: PAYMENT_TYPE_CODE.BILLS }, // bills
]

export const App = () => {
  const dispatch = useDispatch()
  const isFullPageError = useSelector(errorSelector.isFullPageError)
  const isEnforcedMessagePageError = useSelector(errorSelector.isEnforcedMessagePageError)

  // stable, beta 구분
  const versionParam = getParam(version_name) ?? null

  if (versionParam !== null) {
    console.log(versionParam)
    dispatch(versionActions.set(versionParam))

    dispatch(billMainActions.setVersionInfo(`${version_name}=${versionParam}`))

    const versionInfo = `${version_name}=${versionParam}`
    goPaymentMainUrl = `${BILL_PAYMENT_ROUTES.ROOT}?${ENTRY_ROUTE_QUERY}&${versionInfo}&${
      cmodeValue === null ? 'cmode=1' : 'cmode=' + cmodeValue
    }`
  } else {
    goPaymentMainUrl = `${BILL_PAYMENT_ROUTES.ROOT}?${ENTRY_ROUTE_QUERY}`
  }

  // deeplink set param
  const deeplinkParam = getParam(deeplink_name) ?? null
  if (deeplinkParam !== null) {
    const deeplinkFindRow: any = deeplinkArrData.find(v => v.value === deeplinkParam)
    console.log('deeplinkFindRow::::::::::', deeplinkFindRow)
    if (deeplinkFindRow === null) {
      deeplinkFn.set(null)
    } else {
      deeplinkFn.set(deeplinkFindRow.code)
    }
  }

  const $ = useTrans()
  ApiUrlErrorMsg = $('common_error_unknown_desc')

  // Code Splitting 을 위해 수정
  // ROOT.BILL_PAYMENT compoent 찾기
  // const billPaymentComp: any = versionTable.find(v => v.id === (versionParam ?? 'v1'))

  useBackButton(() => {
    goBack()
  })
  useEffect(() => {
    const {
      location: { pathname },
    } = browserHistory
    dispatch(historyActions.push(pathname))

    const unlisten = browserHistory.listen((location, action) => {
      const { pathname } = location

      if (action === HISTORY_ACTION_TYPE.PUSH) {
        dispatch(historyActions.push(pathname))
      } else if (action === HISTORY_ACTION_TYPE.POP) {
        dispatch(historyActions.pop())
      } else if (action === HISTORY_ACTION_TYPE.REPLACE) {
        dispatch(historyActions.redirect(pathname))
      }
    })

    return () => {
      unlisten()
    }
  }, [dispatch])

  if (isFullPageError) {
    return <FullPageError />
  }

  if (isEnforcedMessagePageError) {
    return <EnforcedMessagePageError />
  }

  return (
    <>
      <Switch>
        <Route
          path={ROOT.SCHEDULE_PAYMENT}
          component={getSchedulePaymentComponentByVersion(versionParam ?? 'v1')}
        />
        <Route
          path={ROOT.BILL_PAYMENT}
          component={getBillPaymentComponentByVersion(versionParam ?? 'v1')}
        />
        <Route
          path={ROOT.DEBIT_CARD}
          component={loadable(() => import(/* webpackChunkName: "debit-card" */ './debit-card'))}
        />
        <Route
          path={ROOT.NOTICE}
          component={loadable(() => import(/* webpackChunkName: "notice" */ './notice'))}
        />
        <Route
          path={ROOT.SUPPORT}
          component={loadable(() => import(/* webpackChunkName: "support" */ './support'))}
        />
        <Route
          path={ROOT.NOTIFICATION}
          component={loadable(() =>
            import(/* webpackChunkName: "notification" */ './notification'),
          )}
        />
        <Route
          path={ROOT.PROMOTION}
          component={loadable(() => import(/* webpackChunkName: "promotion" */ './promotion'), {
            fallback: <Loading />,
          })}
        />
        <Route path="*" component={() => <FullPageError isPathError />} />
      </Switch>
      <ErrorSection />
    </>
  )
}
